<template>
  <v-flex xs12 row>

    <v-card v-if="purchase">
      <v-card-title>
        <v-flex xs12 class="text-xs-center">
          <img src="../assets/images/eurotech-logo.jpg">
          <div class="headline text-uppercase">Purchase</div>
        </v-flex>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          
          <v-layout wrap>

            <v-flex xs6>
              <div class="subheading text-uppercase">
                <span>Purchase ID : </span>
                <span>{{purchase.id}}</span>
              </div>
              <div class="body-2 py-2">
                <span>Bill No.: </span>
                <span>{{purchase.bill_number}}</span>
              </div>

            </v-flex>

            <v-flex xs6 class="text-xs-right">
              <div class="body-2 py-2">
                <span>Date: </span>
                <span>{{purchase.date}}</span>
              </div>
            </v-flex>

          </v-layout>

        </v-container>
        <v-divider></v-divider>
        <v-container>
          <v-layout wrap>
            <v-flex xs12>
              <div>
                <div class="v-table__overflow" :class="shrinkClass">
                  <table class="v-datatable v-table">
                    <thead>
                      <tr>
                        <th role="columnheader" scope="col" class="column text-xs-left body-2" v-if="purchase.purchase_type == 1">
                          <span>Item Code</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-left body-2">
                          <span>Item Name</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-left body-2">
                          <span>Unit</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-left body-2">
                          <span>QTY</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-right body-2">
                          <span>Rate</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-right body-2">
                          <span>Tax (%)</span>
                        </th>
                        <th role="columnheader" scope="col" class="column text-xs-right body-2">
                          <span>Amount ({{currency}})</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="purchase.items && purchase.items.length > 0">
                      <tr is="purchase-item" v-for="(item, index) in purchase.items" v-bind:item="item" v-bind:index="index" viewMode="true" :showCode="purchase.purchase_type == 1"></tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="8">No Items Added</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </v-flex>
            <v-flex xs8>
              <v-layout class="align-start justify-end column fill-height pr-3 pb-4">
                <div class="body-2" v-if="amountInWords">
                  <span>Total Amount (In Words): </span>
                  <span class="font-weight-light">{{amountInWords}}</span>
                </div>
              </v-layout>
            </v-flex>
            <v-flex xs4 class="text-xs-right justify-end pr-1 py-3 pr-3">
              <table class="total-table">
                <tbody>
                  <tr class="body-2">
                    <td width="60%">Subtotal: </td>
                    <td width="40%">{{subtotal | roundValue}}</td>
                  </tr>
                  <tr class="body-1">
                    <td>Discount (<span>{{purchase.discount_percent}}</span>%): </td>
                    <td><span v-if="purchase.discount > 0">-</span>{{purchase.discount | roundValue}}</td>
                  </tr>
                  <tr class="body-1">
                    <td>Roundoff: </td>
                    <td>{{purchase.round_off | roundValue}}</td>
                  </tr>
                  <tr class="subheading font-weight-medium" v-if="purchase.tax > 0">
                    <td>Total Amount: </td>
                    <td>{{total | roundValue}}</td>
                  </tr>
                  <tr class="body-1 font-weight-medium" v-if="purchase.tax > 0">
                    <td width="66%">GST ({{ purchase.tax_percent }}%): </td>
                    <td width="34%">{{ purchase.tax | roundValue }}</td>
                  </tr>
                  <tr class="subheading font-weight-medium">
                    <td width="66%">Grand Total ({{currency}}): </td>
                    <td width="34%">{{ purchase.grandtotal | roundValue }}</td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

    </v-card>
    
  </v-flex>
</template>

<script>
  
  import PurchaseItem from './PurchaseItem'

  export default {
    name: 'PrintPurchase',
    data () {
      return {
      	title: "Purchase",
      	processing: false,
        purchase: null
      }
    },
    created () {

    },
    methods: {

      calculateItemTotal (item) {
        return item.quantity * ( item.rate + ( ( item.rate * item.tax_percent ) / 100) )
      },

      loadPurchase (purchaseId) {
        this.processing = true
        this.axios.get(this.config.apis.getPurchase.replace(":id", purchaseId))
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.purchase = response.data.data
              setTimeout(window.print, 200)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      setPageTitle (title) {
        document.title = title
      }

    },
    mounted () {
      if (this.$route.params.id) {
        this.loadPurchase(this.$route.params.id)
        let date = new Date()
        this.setPageTitle(`${this.$route.params.id}-${date.getTime()}`)
      }
      
    },

    computed: {

      subtotal () {
        
        let total = 0
        
        if (this.purchase.items) {
          this.purchase.items.forEach( item => {
            total += item.total
          })
        }
        
        return total
      },

      total () {
        return ( this.subtotal + this.purchase.round_off ) - this.purchase.discount
      },

      shrinkClass () {
        let class_name = null
        
        if (this.purchase && this.purchase.items) {
          let length = this.purchase.items.length
          if (length > 8) {
            class_name = "xs"
          }
          if (length > 10) {
            class_name = "sm"
          }
          if (length > 12) {
            class_name = "md"
          }
          if (length > 14) {
            class_name = "lg"
          }
        }

        return class_name ? `shrink-${class_name}` : ""

      },

      amountInWords () {
        return this.amountToWords(this.purchase.grandtotal)
      }

    },

    watch: {

      '$route' (to, from) {
        // react to route changes...
        if (to !== from && to.params.id) {
          this.loadPurchase(to.params.id)
          let date = new Date()
          this.setPageTitle(`${this.$route.params.id}-${date.getTime()}`)
        }

      }

    },
    
    components: {
      'purchase-item': PurchaseItem,
    }

  }
</script>
